<div class="bg-surface-200 relative h-full overflow-hidden rounded-2xl">
  <div
    class="absolute h-full bg-emerald-500 transition-all"
    [style]="{
      width: (progress() / steps()) * 100 + '%',
    }"
  ></div>
  @for (tick of ticks(); track $index) {
    <div
      class="absolute h-full w-0.5 backdrop-brightness-90 transition-colors"
      [style]="{
        left: (($index + 1) / steps()) * 100 + '%',
      }"
    ></div>
  }
</div>
